import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.includes.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { formRules } from "@/js/form_rules.js";
import { getErrorData, handleErrorData, ERROR_DATA, filterVAutocomplete } from "@/js/forms.js";
import { orderTypes, orderStatus, expeditionMethods, getOrderStatusShortLabel, getOrderStatusLabel, getOrderStatusInt, getOrderStatusInts } from "@/js/lists.ts";
import { getSymbolCurrency, formatPrice } from "@/js/currency/currencies.js";
import { getFullNameUserHtml, getFullNameUser } from "@/js/user/user.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "OrderContainerChapter",
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal
  },
  props: {
    order: Object,
    isExportingXlsFreight: Boolean
  },
  data: function data() {
    return {
      detailsVisibility: false,
      beforeMergeTableHeaders: [{
        text: "Order",
        value: "reference",
        align: "left"
      }, {
        text: "Customer",
        value: "user",
        align: "left"
      }, {
        text: "Delivery",
        value: "deliveryAddress",
        align: "left"
      }, {
        text: "Posting month",
        value: "postingMonth",
        align: "left"
      }, {
        text: "Amount",
        value: "amount",
        align: "center",
        cellCss: "text-nowrap"
      }, {
        text: "NbBottles",
        value: "quantity",
        align: "center"
      }, {
        text: "Actions",
        value: "actions",
        align: "center"
      }],
      afterMergeTableHeaders: [],
      gettingParentContainer: {
        cancellationToken: null,
        isPending: false,
        result: {}
      },
      gettingCompatibleContainers: {
        cancellationToken: null,
        isPending: false,
        result: [],
        form: {
          containerOrderId: null,
          valid: false
        }
      },
      gettingCompatibleOrders: {
        cancellationToken: null,
        isPending: false,
        result: [],
        form: {
          orderId: null,
          valid: false
        }
      },
      updatingSubcontainerInbound: {
        cancellationToken: null,
        isPending: false
      },
      linkingOrder: {
        cancellationToken: null,
        isPending: false
      },
      unlinkingContainer: {
        cancellationToken: null,
        isPending: false
      },
      orderStatus: orderStatus,
      formRules: formRules,
      ERROR_DATA: ERROR_DATA,
      expeditionMethods: expeditionMethods
    };
  },
  computed: {
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.gettingParentContainer.isPending || this.unlinkingContainer.isPending || this.linkingOrder.isPending;
    },
    isContainerOrder: function isContainerOrder() {
      return this.order.type === orderTypes.CONTAINER;
    },
    isContainerOrderBeforeMerge: function isContainerOrderBeforeMerge() {
      return this.isContainerOrder && this.order.isContainerOrderBeforeMerge;
    },
    isContainerOrderDelivered: function isContainerOrderDelivered() {
      return this.isContainerOrder && this.order.status === getOrderStatusInt("DELIVERED");
    },
    isContainerOrderDeliveredWithAnySuborderBeforeDelivery: function isContainerOrderDeliveredWithAnySuborderBeforeDelivery() {
      var allowedStatus = getOrderStatusInts(["DELIVERY", "DELIVERED", "SUBCONTAINER_PUT_INBOUND"]);
      return this.isContainerOrderDelivered && this.order.containerSubOrders.some(function (x) {
        return !allowedStatus.includes(x.status);
      });
    },
    isLinkedToContainerOrder: function isLinkedToContainerOrder() {
      var _this$order$parentCon;
      return ((_this$order$parentCon = this.order.parentContainerOrder) === null || _this$order$parentCon === void 0 ? void 0 : _this$order$parentCon.id_order) > 0;
    },
    isLinkedToContainerOrderBeforeMerge: function isLinkedToContainerOrderBeforeMerge() {
      return this.isLinkedToContainerOrder && this.order.parentContainerOrder.isContainerOrderBeforeMerge;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.afterMergeTableHeaders = _this2.beforeMergeTableHeaders.filter(function (x) {
              return x.value !== "actions";
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this3.refreshData();
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  methods: {
    refreshData: function refreshData() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.detailsVisibility = false;
              _context3.next = 3;
              return _this4.refreshParentContainerData();
            case 3:
              if (_this4.isContainerOrder) _this4.detailsVisibility = true;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    refreshParentContainerData: function refreshParentContainerData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this5$order$parentCo;
        var _this5$gettingParentC, data, _this, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.gettingParentContainer.result = {};
              if (!(((_this5$order$parentCo = _this5.order.parentContainerOrder) === null || _this5$order$parentCo === void 0 ? void 0 : _this5$order$parentCo.id_order) > 0)) {
                _context4.next = 12;
                break;
              }
              _this5.gettingParentContainer.isPending = true;
              (_this5$gettingParentC = _this5.gettingParentContainer.cancellationToken) === null || _this5$gettingParentC === void 0 || _this5$gettingParentC.cancel();
              _this5.gettingParentContainer.cancellationToken = axios.CancelToken.source();
              data = {
                orderIds: [_this5.order.parentContainerOrder.id_order],
                isIncludeSubContainerOrders: true,
                excludeWineDetails: true
              };
              _this = _this5;
              _context4.next = 9;
              return request("/v1/orders", "post", data, true, "api", null, _this5.gettingParentContainer.cancellationToken).catch(function (e) {
                _this.gettingParentContainer.isPending = false;
                var errorData = getErrorData(e, {}, "Unable to get parent container order details.", true);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 9:
              response = _context4.sent;
              _this5.gettingParentContainer.result = response.data.orders[0];
              _this5.gettingParentContainer.isPending = false;
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    confirmUnlinkOrder: function confirmUnlinkOrder(orderId) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this6.$refs.confirm.open("Confirm ?", "Are you sure to unlink this order to the container order ?", {
                width: 600
              });
            case 2:
              ok = _context5.sent;
              if (ok) {
                _this6.unlinkOrder(orderId);
              }
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    unlinkOrder: function unlinkOrder(orderId) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this7$unlinkingConta;
        var _this;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this7.unlinkingContainer.isPending = true;
              (_this7$unlinkingConta = _this7.unlinkingContainer.cancellationToken) === null || _this7$unlinkingConta === void 0 || _this7$unlinkingConta.cancel();
              _this7.unlinkingContainer.cancellationToken = axios.CancelToken.source();
              _this = _this7;
              _context7.next = 6;
              return request("/v1/orders/".concat(orderId, "/container-order"), "delete", null, true, "api", null, _this.unlinkingContainer.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.unlinkingContainer.isPending = false;
                          _this.unlinkingContainer.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to unlink container.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 6:
              _this7.unlinkingContainer.isPending = false;
              _this7.unlinkingContainer.cancellationToken = null;
              _this7.detailsVisibility = false;
              _this7.$toasted.show("Order unlinked to container", {
                type: "success"
              });
              _this7.$emit("orderUnlinked");
            case 11:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    confirmLinkOrderOnCompatibleContainer: function confirmLinkOrderOnCompatibleContainer() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _this8.$refs.confirm.open("Confirm ?", "Are you sure to link this order on this container order ?", {
                color: "red",
                width: 600
              });
            case 2:
              ok = _context8.sent;
              if (ok) {
                _this8.linkOrder(_this8.order.id_order, _this8.gettingCompatibleContainers.form.containerOrderId);
              }
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    confirmLinkOrderOnCompatibleOrder: function confirmLinkOrderOnCompatibleOrder() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this9.$refs.confirm.open("Confirm ?", "Are you sure to link this order on this container order ?", {
                color: "red",
                width: 600
              });
            case 2:
              ok = _context9.sent;
              if (ok) {
                _this9.linkOrder(_this9.gettingCompatibleOrders.form.orderId, _this9.order.id_order);
              }
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    linkOrder: function linkOrder(orderId, containerOrderId) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _this10$linkingOrder$;
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this10.linkingOrder.isPending = true;
              (_this10$linkingOrder$ = _this10.linkingOrder.cancellationToken) === null || _this10$linkingOrder$ === void 0 || _this10$linkingOrder$.cancel();
              _this10.linkingOrder.cancellationToken = axios.CancelToken.source();
              data = {
                orderId: orderId
              };
              _this = _this10;
              _context11.next = 7;
              return request("/v1/container-orders/".concat(containerOrderId, "/order"), "post", data, true, "api", null, _this.linkingOrder.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                    while (1) switch (_context10.prev = _context10.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.linkingOrder.isPending = false;
                          _this.linkingOrder.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to link order to container.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context10.stop();
                    }
                  }, _callee10);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 7:
              _this10.linkingOrder.isPending = false;
              _this10.linkingOrder.cancellationToken = null;
              _this10.detailsVisibility = false;
              _this10.$toasted.show("Order linked to container", {
                type: "success"
              });
              _this10.$emit("orderLinked");
            case 12:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    getCompatibleContainers: function getCompatibleContainers() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _this$gettingCompatib, _this11$order, _this11$order2, _this11$order3;
        var _this, dataForSearch, paramsQuery, response;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this11.gettingCompatibleContainers.isPending = true;
              _this11.gettingCompatibleContainers.form.containerOrderId = null;
              _this = _this11;
              (_this$gettingCompatib = _this.gettingCompatibleContainers.cancellationToken) === null || _this$gettingCompatib === void 0 || _this$gettingCompatib.cancel();
              _this.gettingCompatibleContainers.cancellationToken = axios.CancelToken.source();
              dataForSearch = {
                departureWarehouseId: +((_this11$order = _this11.order) === null || _this11$order === void 0 ? void 0 : _this11$order.id_warehouse),
                arrivalCountryId: +((_this11$order2 = _this11.order) === null || _this11$order2 === void 0 || (_this11$order2 = _this11$order2.delivery_address) === null || _this11$order2 === void 0 || (_this11$order2 = _this11$order2.country) === null || _this11$order2 === void 0 ? void 0 : _this11$order2.id_country),
                currency: (_this11$order3 = _this11.order) === null || _this11$order3 === void 0 ? void 0 : _this11$order3.currency
              };
              paramsQuery = Object.encodeToUri(dataForSearch);
              _context12.next = 9;
              return request("/v1/container-orders/compatibles?params=".concat(paramsQuery), "get", null, true, "api", null, _this.gettingCompatibleContainers.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.gettingCompatibleContainers.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load compatible orders.");
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 9:
              response = _context12.sent;
              _this11.gettingCompatibleContainers.result = _toConsumableArray(response.data.value.map(function (x) {
                var _x$delivery_address$s, _x$delivery_address$s2;
                var formattedPrice = "".concat(formatPrice(x.containerGlobalTotalAmountCurrency), " ").concat(getSymbolCurrency(x.currency));
                x.displayLabel = "#".concat(x.reference_order.shorterReference(), " ").concat(x.delivery_address.country.iso_code).concat((_x$delivery_address$s = x.delivery_address.state) !== null && _x$delivery_address$s !== void 0 && _x$delivery_address$s.iso_state ? "-" + ((_x$delivery_address$s2 = x.delivery_address.state) === null || _x$delivery_address$s2 === void 0 ? void 0 : _x$delivery_address$s2.iso_state) : "", ", ").concat(getFullNameUser(x.user), " : ").concat(formattedPrice, ", ").concat(x.containerNbSubOrders, " suborder(s)");
                return x;
              }));
              _this11.gettingCompatibleContainers.isPending = false;
            case 12:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    getCompatibleOrders: function getCompatibleOrders() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this$gettingCompatib2;
        var _this, dataForSearch, paramsQuery, response;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this12.gettingCompatibleOrders.isPending = true;
              _this12.gettingCompatibleOrders.form.orderId = [];
              _this = _this12;
              (_this$gettingCompatib2 = _this.gettingCompatibleOrders.cancellationToken) === null || _this$gettingCompatib2 === void 0 || _this$gettingCompatib2.cancel();
              _this.gettingCompatibleOrders.cancellationToken = axios.CancelToken.source();
              dataForSearch = {
                departureWarehouseId: +_this12.order.id_warehouse,
                arrivalWarehouseId: +_this12.order.stockTransferWarehouseId,
                currency: _this12.order.currency
              };
              paramsQuery = Object.encodeToUri(dataForSearch);
              _context13.next = 9;
              return request("/v1/container-orders/compatible-orders?params=".concat(paramsQuery), "get", null, true, "api", null, _this.gettingCompatibleOrders.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.gettingCompatibleOrders.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load compatible orders.");
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 9:
              response = _context13.sent;
              _this12.gettingCompatibleOrders.result = _toConsumableArray(response.data.value.map(function (x) {
                var _Object$values$find$t, _Object$values$find, _x$delivery_address$s3, _x$delivery_address$s4;
                var formattedPrice = "".concat(formatPrice(x.total_amount_currency), " ").concat(getSymbolCurrency(x.currency));
                var nbBtls = x.items.reduce(function (acc, x) {
                  return acc + x.quantity;
                }, 0);
                var expMethod = (_Object$values$find$t = (_Object$values$find = Object.values(expeditionMethods).find(function (em) {
                  return em.id === x.expedition_method;
                })) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.text) !== null && _Object$values$find$t !== void 0 ? _Object$values$find$t : "missing expedition method";
                x.displayLabel = "#".concat(x.reference_order.shorterReference(), " ").concat(x.delivery_address.country.iso_code).concat((_x$delivery_address$s3 = x.delivery_address.state) !== null && _x$delivery_address$s3 !== void 0 && _x$delivery_address$s3.iso_state ? "-" + ((_x$delivery_address$s4 = x.delivery_address.state) === null || _x$delivery_address$s4 === void 0 ? void 0 : _x$delivery_address$s4.iso_state) : "", ", ").concat(getFullNameUser(x.user), " : ").concat(formattedPrice, ", ").concat(nbBtls, " btls, ").concat(expMethod, ", ").concat(getOrderStatusShortLabel(x.status));
                return x;
              }));
              _this12.gettingCompatibleOrders.isPending = false;
            case 12:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    confirmUpdateSubcontainerInbound: function confirmUpdateSubcontainerInbound() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var question, confirmed;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              question = "";
              if (_this13.order.isSubcontainerPutInbound) {
                question = "Are you sure you want to define this order as Put Inbound, and create reserved stock instead of an immediate delivery ?";
              } else {
                question = "Are you sure you want to define this order as immediate delivery instead of creating a reserved stock ?";
              }
              _context14.next = 4;
              return _this13.$refs.confirm.open("Confirm", question, {
                color: "red"
              });
            case 4:
              confirmed = _context14.sent;
              if (confirmed) {
                _this13.updateSubcontainerInbound();
              } else {
                _this13.order.isSubcontainerPutInbound = !_this13.order.isSubcontainerPutInbound;
              }
            case 6:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    updateSubcontainerInbound: function updateSubcontainerInbound() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var _this14$updatingSubco;
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _this14.updatingSubcontainerInbound.isPending = true;
              (_this14$updatingSubco = _this14.updatingSubcontainerInbound.cancellationToken) === null || _this14$updatingSubco === void 0 || _this14$updatingSubco.cancel();
              _this14.updatingSubcontainerInbound.cancellationToken = axios.CancelToken.source();
              data = {
                isSubcontainerPutInbound: _this14.order.isSubcontainerPutInbound
              };
              _this = _this14;
              _context15.next = 7;
              return request("/v1/container-orders/".concat(+_this14.order.id_order, "/subcontainer-inbound"), "put", data, true, "api", null, _this14.updatingSubcontainerInbound.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.updatingSubcontainerInbound.isPending = false;
                  _this.updatingSubcontainerInbound.cancellationToken = null;
                  var errorData = getErrorData(e, "Unable to change action of this suborder", true);
                  handleErrorData(_this, errorData);
                  _this14.order.isSubcontainerPutInbound = !_this14.order.isSubcontainerPutInbound;
                }
                throw e;
              });
            case 7:
              _this14.$toasted.show("Suborder action changed", {
                type: "success"
              });
              _this14.updatingSubcontainerInbound.isPending = false;
            case 9:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    getSuborderStatusClass: function getSuborderStatusClass(suborderStatus) {
      if (this.isContainerOrderDelivered) {
        return suborderStatus === getOrderStatusInt("CANCELLED") ? "danger" : getOrderStatusInts(["SUBCONTAINER_PUT_INBOUND"]).includes(suborderStatus) ? "info" : getOrderStatusInts(["DELIVERY", "DELIVERED"]).includes(suborderStatus) ? "success" : "warning";
      } else {
        return suborderStatus === getOrderStatusInt("CANCELLED") ? "danger" : getOrderStatusInts(["SUBCONTAINER_PUT_INBOUND"]).includes(suborderStatus) ? "info" : "success";
      }
    },
    orderDetails: function orderDetails(orderId) {
      var routeParams = {};
      return {
        name: "adminOrderSummary",
        params: {
          id: orderId,
          routeParams: routeParams
        }
      };
    },
    exportXlsFreight: function exportXlsFreight() {
      this.$emit("exportXlsFreight");
    },
    getOrderStatusLabel: getOrderStatusLabel,
    getFullNameUserHtml: getFullNameUserHtml,
    formatPrice: formatPrice,
    getSymbolCurrency: getSymbolCurrency,
    filterVAutocomplete: filterVAutocomplete
  },
  watch: {
    detailsVisibility: function detailsVisibility(newVal, oldVal) {
      if (!this.isLinkedToContainerOrder && !this.isContainerOrder) {
        if (newVal) {
          this.getCompatibleContainers();
        } else {
          var _this$gettingCompatib3;
          (_this$gettingCompatib3 = this.gettingCompatibleContainers.cancellationToken) === null || _this$gettingCompatib3 === void 0 || _this$gettingCompatib3.cancel();
        }
      } else if (this.isContainerOrderBeforeMerge) {
        if (newVal) {
          this.getCompatibleOrders();
        } else {
          var _this$gettingCompatib4;
          (_this$gettingCompatib4 = this.gettingCompatibleOrders.cancellationToken) === null || _this$gettingCompatib4 === void 0 || _this$gettingCompatib4.cancel();
        }
      }
    }
  }
};